
import UserHelper from './UserHelper';

export default {
    UserHelper: new UserHelper()
}